import React, { Component } from "react";

export default class HcsVersionInfo extends Component {
    constructor(props) {
        super(props);
    }

    /**
     * Returns elements visibility state.
     * @returns {boolean} Elements visibility state.
     */
    isVisible() {
        let { hcs } = this.props;

        return hcs.settings.get("SETTINGS.SHOW_VERSION_INFO", "bool");
    }

    render() {
        let { hcs } = this.props;

        return this.isVisible() ?
            <div className="hcs-version-info">
                <span>App Version: {hcs.settings.get("SETTINGS.BUILD_VERSION")}</span>
                <span>DB Version: {hcs.settings.get("VERSION.DATABASE")}</span>
                <span>CFG Version: {hcs.settings.get("VERSION.CONFIGURATOR")}</span>
                <span>Env: {hcs.api.emptyReplace(hcs.settings.get("SETTINGS.APP_CONFIGURATION_ID"), "-")}</span>
            </div>
            : null;
    }
}